import { RootState } from './store';

/**
 * Get field options for a specific entity type from the Redux store
 * This can be used outside of React components or in callbacks
 */
export function getFieldOptionsForEntityType(state: RootState, entityType: string): Array<{
    name: string;
    id: string;
    value: string;
    label: string;
    type: string;
    required: boolean;
    multiValued: boolean;
    isReference: boolean;
    computed: boolean;
}> {
    if (!entityType || typeof entityType !== 'string') {
        return [];
    }

    const schemas = state.schema.processedSchemas;

    // Find the schema for this entity type (case-insensitive)
    const schema = schemas.find((s) => {
        const schemaId = s.id?.toLowerCase() || '';
        const searchType = entityType.toLowerCase();
        return schemaId === searchType ||
            schemaId === `urn:dcps:scim:v1:${searchType}` ||
            schemaId === `urn:ietf:params:scim:schemas:core:2.0:${searchType}` ||
            schemaId.includes(searchType);
    });

    if (!schema || !schema.attributes) {
        return [];
    }

    return schema.attributes.map((attr) => {
        const attrName = attr.name || '';
        const attrId = attr.id || attrName;

        return {
            name: attrName,
            id: attrId,
            value: attrId,
            label: attrName,
            type: attr.type || 'string',
            required: attr.required || false,
            multiValued: attr.multiValued || false,
            isReference: attr.isReference || false,
            computed: attr.computed || false
        };
    });
}

